<template>
  <div class="popup_add_take_form">
    <div class="add_take_content">
      <ul class="add_take_content_ul">
        <li v-for="ele in formEleData" :key="ele.key">
          <component
            :is="ele.componentName"
            :ele-data="ele"
            @changeEleData="changeEleData"
          />
          <div v-if="accountType === 'take'">
            <p
              v-if="ele.key === 'baof' && !formValues.baof"
              class="add_take_content_tips"
            >
              根据低档收益，最大领取金额约
              {{ getMinAmount() }} 元<br>仅供参考，实际领取以保单账户价值为准
            </p>
            <div class="add_take_content_purpose">
              <input
                v-if="
                  ele.key === 'purposeType' &&
                    !formEleData[formEleData.length - 2].value
                "
                v-model.lazy="formEleData[formEleData.length - 1].value"
                type="text"
                placeholder="请输入用途"
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="warn_tips">
      温馨提示：以上演示说明为本平台对上述产品的理解便于保险从业人员学习、交流，演示数据仅供参考，请以实际为准。
    </div>
  </div>
</template>

<script>
import cmCommonInput from '@/components/inputAtom/commonFormInput'
import cmCommonSelect from '@/components/inputAtom/commonFormSelect'

export default {
  name: 'PopupAddAndTakeForm',
  components: {
    cmCommonInput,
    cmCommonSelect
  },
  props: {
    age: Number,
    accountData: Object,
    allAddAndTakeData: Object,
    popopBaseConf: Object,
    formEleData: Array
  },
  data() {
    return {
      instanceScroll: null,
      currentAddAndTakeData: this.accountData.addAndTakeData.filter(
        ad => ad.key === this.popopBaseConf.accountType
      )[0],
      purposeOpts: this.initPurposeOpts()
    }
  },
  computed: {
    formValues() {
      return this.popopBaseConf.formValues
    },
    accountType() {
      return this.popopBaseConf.accountType
    },
    bonusType() {
      return this.popopBaseConf.bonusType
    }
  },
  created() {
    let self = this
    self.formEleData.map(ele => {
      switch (ele.key) {
        case 'beginYear':
          ele.opts = self.getBeginYearOpts()
          break
        case 'endYear':
          ele.opts = self.getEndYearOpts()
          break
        case 'baof':
          ele.value = self.formValues.baof || null
          break
        case 'purposeType':
          if (self.purposeOpts.some(p => p.val === self.formValues.purpose)) {
            ele.value = self.formValues.purpose
          } else {
            ele.value = self.purposeOpts[self.purposeOpts.length - 1].val
          }
          ele.opts = this.initPurposeOpts()
          break
        case 'purpose':
          if (self.purposeOpts.some(p => p.val === self.formValues.purpose)) {
            ele.value = ''
          } else {
            ele.value = self.formValues.purpose
          }
          break
      }
    })
  },
  methods: {
    bscroll(instance) {
      instance.options.click = true
      this.instanceScroll = instance
    },
    initPurposeOpts() {
      return [
        '高中教育金',
        '大学教育金',
        '婚嫁金',
        '子女教育金',
        '养老金',
        '自己填写'
      ].map(ele => {
        return {
          val: ele === '自己填写' ? '' : ele,
          desc: ele
        }
      })
    },
    getBeginYearOpts() {
      let numMaxlength = 0
      if (this.allAddAndTakeData.data) {
        this.allAddAndTakeData.data.map(d => {
          if (d.values.length) {
            numMaxlength = Math.max(numMaxlength, d.values.length)
          }
        })
      }
      let yearOpts = []
      for (let i = 0; i < numMaxlength; i++) {
        let year = i + 1
        if (year >= this.formValues.beginYear) {
          yearOpts.push({
            val: year,
            desc: `第${i + this.allAddAndTakeData.startPolicyNo}年,${this.age +
              year +
              this.allAddAndTakeData.startIndex}岁`
          })
        }
      }
      if (
        this.formValues.baof === 0 &&
        this.currentAddAndTakeData &&
        this.currentAddAndTakeData.adjustData &&
        this.currentAddAndTakeData.adjustData.length
      ) {
        let nextRecord = this.currentAddAndTakeData.adjustData.filter(
          ad => this.formValues.beginYear < ad[0]
        )[0]
        if (nextRecord) {
          yearOpts = yearOpts.filter(y => y.val < nextRecord[0])
        }
      }
      return yearOpts
    },
    getEndYearOpts() {
      let beginYear = this.formEleData
        ? this.getFormData(this.formEleData).beginYear
        : this.formValues.beginYear
      return this.getBeginYearOpts().filter(y => y.val >= beginYear)
    },
    getFormData(list = []) {
      let data = {}
      list.map(e => {
        data[e.key] = e.value
      })
      return data
    },
    changeEleData(vueInstance) {
      if (vueInstance.eleData.key === 'beginYear') {
        this.formEleData.map(ele => {
          if (ele.key === 'endYear') {
            ele.opts = this.getEndYearOpts()
          }
        })
      }
    },
    getMinAmount() {
      // 保证利率
      let rate = this.allAddAndTakeData.rate.opts[0].value + 1

      // 账户价值
      let accountValue = this.allAddAndTakeData.data.filter(
        ele => ele.key === 'account_value'
      )[0]
      let minAmount = 0
      let formValues = this.getFormData(this.formEleData)
      if (
        formValues.beginYear &&
        formValues.endYear &&
        accountValue &&
        accountValue.values &&
        rate
      ) {
        for (let k = formValues.beginYear; k <= formValues.endYear; k++) {
          let curValue =
            (accountValue.values[k - 1] * (1 - rate)) /
            (1 - Math.pow(rate, k - formValues.beginYear + 1)) /
            rate
          minAmount = minAmount ? Math.min(minAmount, curValue) : curValue
        }
      }

      let numMaxlength = 0
      if (this.allAddAndTakeData.data) {
        this.allAddAndTakeData.data.map(d => {
          if (d.key === 'account_value' && d.values && d.values.length) {
            numMaxlength = d.values.length
          }
        })
      }
      if (
        formValues.beginYear &&
        formValues.endYear &&
        numMaxlength &&
        formValues.endYear <= numMaxlength
      ) {
        for (let i = formValues.endYear + 1; i <= numMaxlength; i++) {
          minAmount = Math.min(
            minAmount,
            accountValue.values[i - 1] /
              (formValues.endYear - formValues.beginYear + 1) /
              Math.pow(
                rate,
                i - (formValues.beginYear + formValues.endYear - 1) / 2
              )
          )
        }
      }

      let precision = Math.max(
        Math.pow(10, Math.floor(Math.log(minAmount) / Math.log(10) - 2)),
        100
      )
      return minAmount ? Math.floor(minAmount / precision) * precision : 0
    }
  }
}
</script>

<style lang="postcss" scoped>
input {
  font-size: 0.28rem;
  color: #333;
  border: none;
  vertical-align: middle;
  background: transparent;
  appearance: none;
  &::-webkit-input-placeholder {
    color: #ccc;
  }
}
input[type='tel'],
input[type='text'] {
  width: 2.56rem;
  height: 0.54rem;
  padding: 0.1rem 0.12rem 0.06rem;
  border: 1px solid #e5e5e5;
  border-radius: 0.04rem;
}
.popup_add_take_form {
  padding: 0.2rem;
  background: #f2f2f2;
  .add_take_content {
    position: relative;
    padding: 0.3rem;
    font-size: 0.26rem;
    color: #666;
    background: #fff;
    border-radius: 0.12rem;
    .add_take_content_ul {
      li {
        .add_take_content_tips {
          line-height: 145%;
          color: #999;
          font-size: 0.24rem;
        }
        .add_take_content_purpose {
          text-align: right;
          > input {
            min-width: 50%;
            margin: 0 0 0.16rem 0;
          }
        }
      }
    }
  }
  .warn_tips {
    line-height: 145%;
    padding: 0.24rem 0 0.12rem;
    font-size: 0.24rem;
    color: #999;
  }
}
</style>
